import TTree from './tree.vue'
export default TTree



// WEBPACK FOOTER //
// ./src/components/tree/index.js